// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinning-text__text[data-v-61d30870]{color:#657182;line-height:20px}", ""]);
// Exports
module.exports = exports;
